"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("lodash");
var parjs_1 = require("parjs");
var __1 = require("..");
var geometry_1 = require("../geometry");
var global_1 = require("../global");
var log_1 = require("../log");
var utils_1 = require("./utils");
var logger = log_1.getLogger("template/bvt");
var FUNCTION_REGEX = RegExp(/\((.*)\) *\{((.|\n)+)\}/);
var COMP_NAME_REGEX = RegExp(/^(.+?)(\[(.+?)\])?(\((.*?)\))?$/m);
var MODIFIERS = [
    { name: "group", parse: function (obj) { return obj._isGroup = true; } },
    { name: "auto", parse: function (obj) { return obj._autoSize = true; } },
    { name: "abs", parse: function (obj) { return obj._absPos = true; } },
    { name: "fs", parse: function (obj) {
            obj._width = geometry_1.GeometryValue.fullSize;
            obj._height = geometry_1.GeometryValue.fullSize;
        } },
    { name: "fw", parse: function (obj) {
            obj._width = geometry_1.GeometryValue.fullSize;
        } },
    { name: "fh", parse: function (obj) {
            obj._height = geometry_1.GeometryValue.fullSize;
        } },
    { name: "lt", parse: function (obj) {
            obj._anchor = 16 /* Left */ | 2 /* Top */;
        } },
    { name: "lm", parse: function (obj) {
            obj._anchor = 16 /* Left */ | 4 /* Middle */;
        } },
    { name: "lb", parse: function (obj) {
            obj._anchor = 16 /* Left */ | 8 /* Bottom */;
        } },
    { name: "crisp", parse: function (obj) {
            obj["shape-rendering"] = "crispEdges";
        } },
];
var attrName = parjs_1.Parjs.any(parjs_1.Parjs.string("$"), parjs_1.Parjs.string("."), parjs_1.Parjs.string("-"), parjs_1.Parjs.string("_"), parjs_1.Parjs.letter, parjs_1.Parjs.digit).many(1).str;
var attrNameWithColon = parjs_1.Parjs.anyCharOf(":@").soft.maybe("").then(attrName);
var attrExpValue = parjs_1.Parjs.anyChar.manyTill(parjs_1.Parjs.string(";")).str;
var attrFuncValue = parjs_1.Parjs.string("(").q
    .then(parjs_1.Parjs.anyChar.manyTill(parjs_1.Parjs.string(")")).str)
    .then(parjs_1.Parjs.whitespaces.q)
    .then(parjs_1.Parjs.string("{").q)
    .then(parjs_1.Parjs.anyChar.manyTill(parjs_1.Parjs.string("};")).str)
    .map(function (_a) {
    var args = _a[0], body = _a[1];
    return ({
        __function__: true,
        args: args.split(",").map(function (x) { return x.trim(); }),
        body: body.trim(),
    });
});
var attrValue = attrFuncValue.soft.or(attrExpValue);
var eql = parjs_1.Parjs.string("=").between(parjs_1.Parjs.space.many()).q;
var attrExp = attrNameWithColon.then(eql).then(attrValue).map(function (_a) {
    var _b = _a[0], opt = _b[0], name = _b[1], value = _a[1];
    return ({ name: name, value: value, opt: opt });
});
var compName = parjs_1.Parjs.noCharOf("{}").many(1).str;
var _compBlock = null;
var compBlock = parjs_1.Parjs.late(function () { return _compBlock; });
var member = attrExp.soft.or(compBlock).between(parjs_1.Parjs.whitespaces);
var blockBody = member.many().between(parjs_1.Parjs.string("{"), parjs_1.Parjs.string("};"));
_compBlock = compName.between(parjs_1.Parjs.whitespaces)
    .then(blockBody).map(function (_a) {
    var component = _a[0], members = _a[1];
    return ({
        component: parseComponentName(component.trim()),
        children: members.filter(function (m) { return m.component !== undefined; }),
        attrs: members.filter(function (m) { return m.name !== undefined; }),
    });
});
var completeParser = compBlock.between(parjs_1.Parjs.whitespaces);
function parseComponentName(nameDef) {
    var result = nameDef.match(COMP_NAME_REGEX);
    var geoDef = result[3];
    var nameWithModifiers = result[1];
    var args = result[5];
    var _a = nameWithModifiers.split("."), tagName = _a[0], modifiers = _a.slice(1);
    var _b = geoDef ?
        geoDef.split(":").map(function (x) { return geometry_1.GeometryValue.parse(x.trim()); }) :
        [null, null, null, null], x = _b[0], y = _b[1], width = _b[2], height = _b[3];
    return {
        name: tagName.trim(),
        modifiers: new Set(modifiers.map(function (m) { return m.trim(); })),
        geo: { x: x, y: y, width: width, height: height },
        args: args ? args.split(",").map(function (x) { return JSON.parse(x.trim()); }) : [],
    };
}
function handleElement(element, isRoot) {
    if (isRoot === void 0) { isRoot = false; }
    var obj = {
        _type: element.component.name,
        _on: {},
        _isGroup: false,
    };
    MODIFIERS.forEach(function (_a) {
        var name = _a.name, parse = _a.parse;
        if (element.component.modifiers.has(name)) {
            parse(obj);
        }
    });
    _.forOwn(element.component.geo, function (value, geoAttr) {
        if (value) {
            obj["_" + geoAttr] = value;
        }
    });
    obj.__args__ = element.component.args;
    for (var _i = 0, _a = element.attrs; _i < _a.length; _i++) {
        var attr = _a[_i];
        if (attr.opt === "@") {
            obj._on[attr.name] = parseValue(attr);
        }
        else {
            var attrName_1 = attr.opt === ":" ? "_" + attr.name : attr.name;
            obj[attrName_1] = parseValue(attr);
        }
    }
    // children
    if (element.children.length > 0) {
        obj._children = element.children.map(function (x) { return handleElement(x); });
    }
    return obj;
}
var anchorMap = {
    top: 2 /* Top */, bottom: 8 /* Bottom */, middle: 4 /* Middle */,
    left: 16 /* Left */, right: 64 /* Right */, center: 32 /* Center */,
};
var gravityMap = {
    top: __1.Gravity.Top, bottom: __1.Gravity.Bottom, left: __1.Gravity.Left, right: __1.Gravity.Right,
};
function parseValue(attr, noFuncParam, noGeometry) {
    if (noFuncParam === void 0) { noFuncParam = false; }
    if (noGeometry === void 0) { noGeometry = false; }
    if (typeof attr.value === "object") {
        if (attr.value.__function__) {
            return new (Function.bind.apply(Function, __spreadArrays([void 0], attr.value.args, [attr.value.body])))();
        }
        else {
            logger.error("Fatal error: Unknown attr value object");
        }
    }
    else if (attr.value[0] === "@") {
        // binding
        var key = attr.value.substr(1);
        // event handler
        if (attr.opt === "@") {
            return global_1.default.currentVisualizer.eventHandlers[key];
        }
        // transformer
        var match = key.match(/(.+?)\((.*)\)$/);
        if (match) {
            return global_1.default.currentVisualizer.transformers[key.substr(0, key.length - 2)];
        }
        // data
        if (attr.opt === ":" && (attr.name === "data" || attr.name === "datum")) {
            return { __dataKey__: key };
        }
        return global_1.default.currentVisualizer.data[key];
    }
    else if (attr.value[0] === ">") {
        // function shortcut
        var body = attr.value.substr(1)
            .replace(/([^A-z0-9])\.\[(.+?)\]/g, function (s, m1, m2) { return m1 + "d[" + m2 + "]"; })
            .replace(/([^A-z0-9\)])\./g, function (s, m1) { return m1 + "d."; })
            .replace(/@([\w_][\d\w_]+)/g, function (s, m1) { return "this.$visualizer.data[\"" + m1 + "\"]"; })
            .replace(/%g\((.+?)\)/g, function (s, m1) { return "{value:(" + m1 + "),unit:0}"; });
        if (noFuncParam) {
            return new Function("return " + body);
        }
        else {
            return new Function("d", "i", "g", "h", "return " + body);
        }
    }
    else if (attr.value[0] === "(") {
        // function
        var match = attr.value.match(FUNCTION_REGEX);
        if (match) {
            return new (Function.bind.apply(Function, __spreadArrays([void 0], match[1].split(",").map(function (x) { return _.trim(x); }), [match[2]])))();
        }
        else {
            logger.error("Invalid function syntax " + attr.value);
            return null;
        }
    }
    else {
        // anchor
        if (attr.opt === ":" && (attr.name === "anchor" || attr.name === "relatedTo")) {
            return attr.value.split(" ").map(function (x) { return anchorMap[x]; }).reduce(function (p, c) { return p | c; });
        }
        if (attr.opt === ":" && attr.name === "gravity") {
            return gravityMap[attr.value];
        }
        // geometry
        if (!noGeometry && (attr.name === "x" || attr.name === "y" ||
            attr.name === "width" || attr.name === "height")) {
            return utils_1.parseGeometry(attr.value);
        }
        // color
        if (attr.value[0] === "#" || _.startsWith(attr.value, "rgb")) {
            return attr.value;
        }
        // svg attr
        if (attr.opt.length === 0 && attr.value[0] !== "\"") {
            return attr.value;
        }
        // json value
        try {
            return JSON.parse(attr.value);
        }
        catch (_a) {
            logger.error("Unknown attribute value: " + attr.value);
            return null;
        }
    }
}
function parse(template) {
    var result = completeParser.parse(template);
    if (result.kind !== parjs_1.ReplyKind.Ok) {
        logger.error("Error parsing template:");
        // tslint:disable-next-line
        console.log(parjs_1.Parjs.visualizer(result.trace));
    }
    else {
        var value = result.value;
        if (value.component.name !== "svg") {
            logger.error("Missing svg definition.");
            return;
        }
        if (value.children.length !== 1) {
            logger.error("You must have exactly one root element.");
            return;
        }
        for (var _i = 0, _a = value.attrs; _i < _a.length; _i++) {
            var attr = _a[_i];
            if (attr.name === "height" || attr.name === "width") {
                global_1.default.currentVisualizer.size[attr.name] = parseValue(attr, true, true);
            }
        }
        return handleElement(value.children[0], true);
    }
}
var parser = { parse: parse };
exports.default = parser;
//# sourceMappingURL=bvt.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/template/bvt.js
// module id = 887
// module chunks = 0 1